module.exports = __webpack_public_path__ + "media/svg/th-a65cc9bc.svg";